<!-- FOOTER -->
<footer id="footer" class="footer footerDiv">
  <div class="container py-4">
    <div class="row">
      <div class="col-lg-1">
        <img src="assets/img/Rank Ahead.png" alt="rank ahead" width="60" class="footer-logo">
      </div>
      <div class="col-lg-3 col-md-6 m0Auto">
        <h1>Rank Ahead</h1>
        <p class="small"><a [routerLink]="['/privacy-policy']">Privacy</a> | <a [routerLink]="['/terms']">Terms</a></p>
        <p class="small">&copy; {{fullYear}} <a class="text-primary" [routerLink]="['/']">rankahead.app</a> All rights reserved.</p>
      </div>
      <div class="col-lg-2 col-md-6">
        <h5 class="mt-2">Quick links</h5>
        <ul class="list-unstyled">
          <li><h6 class="heading"><a [routerLink]="['/faq']">Faq</a></h6></li>
          <li><h6 class="heading"><a [routerLink]="['/blog']">Blog</a></h6></li>
          <li><h6 class="heading"><a [routerLink]="['/pricing']">Pricing</a></h6></li>
          <li><h6 class="heading"><a [routerLink]="['/seo-tools']">Free SEO Tools</a></h6></li>
        </ul>
      </div>
      <div class="col-lg-3 col-md-6">
        <h5 class="mt-2">Blog</h5>
        <div class="block-21 d-flex">

          <div class="text">
            <h6 class="heading"><a [routerLink]="['/blog/importance-of-google-indexing']">The Importance of Google Indexing</a></h6>
          </div>
        </div>
        <div class="block-21 d-flex">
          <div class="text">
            <h6 class="heading"><a [routerLink]="['/blog/how-to-add-your-website-to-google-search-console']">How to Add Your Website to Google Search Console</a></h6>
          </div>
        </div>
      </div>
      <div class="col-lg-1 col-md-6">
        <h5 class="mt-2">Social</h5>
        <ul class="list-unstyled">
          <li><h6 class="heading"><a href="https://twitter.com/rankaheadapp" class="twitter"><i class="bi bi-twitter"></i></a></h6></li>
        </ul>
      </div>
      <div class="col-lg-1 col-md-6 col-desktop-padding-0">
        <h5 class="mt-2">Contact Us</h5>
        <ul class="list-unstyled">
          <li><h6 class="heading"><a href="mailto:support@rankahead.app" class="facebook"><i class="bi bi-envelope"></i></a></h6></li>
        </ul>
      </div>
      <div class="col-lg-1">

      </div>
    </div>
  </div>
</footer>
